import React from 'react'
import withBulkAction from '../with-bulk-action/with-bulk-action'
import FormCheckbox from 'pobble-components/dist/form-elements/form-checkbox'
import PropTypes from 'prop-types'

const BulkCheckbox = ({ bulkToggle, bulkSelected, id }) => (
  <FormCheckbox checked={!!bulkSelected[id]} onChange={() => bulkToggle(id)} />
)

BulkCheckbox.propTypes = {
  /** Id of the entity */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

export default withBulkAction(BulkCheckbox)
